// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"903d6b1c7c0a7a467b34","453":"323b02bfa52f2ba95cdd"}[chunkId] + ".js";
};